import script from "./PatientCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientCards.vue?vue&type=script&setup=true&lang=ts"

import "./PatientCards.vue?vue&type=style&index=0&id=f1d37530&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1d37530"]])

export default __exports__